import React from 'react';
import { EditorControls } from 'browser-editor';

const EditorControlsContext = React.createContext<EditorControls | null>(
  null,
);

export default EditorControlsContext;
